import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Icon } from '../../components/Icon/Icon.js';
import { Tooltip } from 'primereact/tooltip';
import { prepareLabel } from '../prepare-label.js';
import s from './InputLabel.module.scss.js';

function InputLabel(_ref) {
  let {
    id,
    labelHidden,
    horizontal,
    labelClassName: labelClassNameProps,
    labelTooltip,
    label,
    field,
    required,
    suppressRequiredLabel,
    bulkMode
  } = _ref;
  if (labelHidden) {
    return null;
  }
  const labelClassName = clsx(labelClassNameProps, horizontal ? s.label : null, 'flex gap-2');
  return jsxs("label", {
    htmlFor: id || (field === null || field === void 0 ? void 0 : field.name),
    className: labelClassName,
    children: [prepareLabel(field === null || field === void 0 ? void 0 : field.name, label, suppressRequiredLabel ? false : required, bulkMode), labelTooltip ? jsxs(Fragment, {
      children: [jsx(Icon, {
        id: "info-icon",
        name: "info"
      }), jsx(Tooltip, {
        target: "#info-icon",
        children: labelTooltip
      })]
    }) : null]
  });
}

export { InputLabel };
